
export default {
  props: {
    addressSummaryInfo: {
      type: [Array, Object],
    },
    countryName: {
      type: String,
    },
  },
};
